/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./postgate.defs.js";
export { main as default } from "./postgate.defs.js";
